import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { currentTimeMillis, formatTimestamp, MUSTNeverHappenException } from '@nu-art/ts-common';
import { _className, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import * as React from 'react';
import './Printable_OrderMapping.scss';
import { ModuleFE_Action } from '@app/pathway-frontend';
import { ModuleFE_EHRInstallation } from '../../../../../_entity/installation/index.js';
export class Printable_OrderMapper extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    renderHeader = () => {
        return _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Quai Order Name" }), _jsx("th", { children: "Quai Order Id" }), _jsx("th", { children: "Installation Order Id" })] }) });
    };
    renderOrderRow = (installationOrder) => {
        const dbOrder = ModuleFE_Action.cache.unique(installationOrder.orderId);
        if (!dbOrder)
            throw new MUSTNeverHappenException(`cannot find db order with id ${installationOrder.orderId}`);
        return _jsxs("tr", { children: [_jsx("td", { children: dbOrder.name }), _jsx("td", { children: installationOrder.orderId }), _jsx("td", { className: _className(!installationOrder.ehrInstallationOrderId && 'missing-ehr-id'), children: installationOrder.ehrInstallationOrderId ?? '-' })] });
    };
    renderCopyright = () => {
        const currentTimeFormatted = formatTimestamp('YYYY-MM-DD HH:mm', currentTimeMillis());
        const currentYear = new Date().getFullYear();
        const installation = ModuleFE_EHRInstallation.cache.unique(this.props.installationId);
        const latestOrderTime = this.getLatestOrderTime();
        if (!installation)
            throw new MUSTNeverHappenException(`cannot resolve ehr installation with id ${installation}`);
        const nameLabel = latestOrderTime ? `${installation.label} | ${latestOrderTime}` : installation.label;
        return _jsxs(LL_H_C, { className: 'printable__order-mapping__footer', children: [_jsx("span", { className: 'printable__order-mapping__footer__name', children: nameLabel }), _jsxs("span", { className: 'printable__order-mapping__footer__copyright', children: ["Generated At: ", currentTimeFormatted, " Quai.MD \u00A9 Copyright ", currentYear] })] });
    };
    getLatestOrderTime = () => {
        const installationOrders = this.props.installationOrders;
        if (!installationOrders.length)
            return;
        return installationOrders.reduce((latest, order) => order.__updated > latest.__updated ? order : latest, installationOrders[0]).__updated;
    };
    render() {
        const installationOrders = this.props.installationOrders;
        return _jsxs(LL_V_L, { id: 'printable__order-mapping', children: [this.renderCopyright(), _jsxs("table", { children: [this.renderHeader(), _jsx("tbody", { children: installationOrders.map((installationOrder, index) => _jsx(React.Fragment, { children: this.renderOrderRow(installationOrder) }, index)) })] })] });
    }
}
//# sourceMappingURL=Printable_OrderMapping.js.map